import { Col } from 'reactstrap'
import { UL } from '../../../AbstractElements'
import ResponsiveSearchInput from './responsive-search-input/ResponsiveSearchInput'
import ZoomInOut from './zoom-in-out/ZoomInOut'
import Language from './language/Language'
import Notifications from './notifications/Notifications'
import HeaderBookmark from './header-book-mark/HeaderBookmark'
import DarkMode from './dark-mode/DarkMode'
import HeaderMessage from './header-message/HeaderMessage'
import HeaderCart from './header-cart/HeaderCart'
import UserProfile from './user-profile/UserProfile'

const RightHeaderIcon = () => {
  return (
    <Col xxl="7" xl="8" className="nav-right col-auto box-col-6 pull-right right-header p-0 ms-auto">
      <UL className="nav-menus flex-row">
        <ResponsiveSearchInput />
        <ZoomInOut />
        <Language />
        <Notifications />
        <HeaderBookmark />
        <DarkMode />
        <HeaderMessage />
        {/* <HeaderCart /> */}
        <UserProfile />
      </UL>
    </Col>
  )
}

export default RightHeaderIcon